function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v4.474H2.368L0,7.5Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.368,12.763h27.632v4.474H2.368v-4.474Z",
    style: {
      fill: "#da121a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.368,18.026h27.632v4.474H0l2.368-4.474Z",
    style: {
      fill: "#078930"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.99,15L0,22.5V7.5l12.99,7.5Z",
    style: {
      fill: "#45b4db"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.993,17.261l-1.469-4.523-1.469,4.522,3.847-2.795H2.146l3.847,2.796Z",
    style: {
      fill: "#fcdd09"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs);
export default __webpack_public_path__ + "static/media/SS.08a3e707d3af40ffe7c4f624362bd5e5.svg";
export { ForwardRef as ReactComponent };